import * as React from 'react';
import { useEffect, useRef } from 'react';
import { offset, position } from './type';
import { assert } from '../../lib/utils';

export default function ({ path, onDrag, onWheel }: {
    path: string,
    onDrag: (offset: offset) => void,
    onWheel?: (e: WheelEvent) => void,
}) {
    const div = useRef<HTMLDivElement>(null);
    const pos = useRef<position | null>(null);

    useEffect(() => {
        fetch(path)
        .then(res => res.text())
        .then(html => {
            assert(div.current !== null, '');
            // ref: https://github.com/christo-pr/dangerously-set-html-content
            // Create a 'tiny' document and parse the html string
            const slotHtml = document.createRange().createContextualFragment(html);
            div.current.innerHTML = '';
            div.current.appendChild(slotHtml);
        });
    }, []);

    const style: React.CSSProperties = {
        position: 'relative',               // 讓 page 裡面 position=absolute 的元素定位到這個頁面裡
    }
    return (
    <div
        ref={div}
        style={style}
        data-page='__ebook_page'
        data-dir={basedir(path)}
        onWheel={e => {
            if (onWheel) {
                onWheel(e.nativeEvent);
            }
        }}
        onMouseDown={e => pos.current = { x: e.screenX, y: e.screenY }}
        onMouseUp={e => pos.current = null}
        onMouseMove={e => {
            if (pos.current !== null) {
                const [x, y] = [e.screenX, e.screenY];
                onDrag({
                    x: (x - pos.current.x),
                    y: (y - pos.current.y),
                });
                pos.current = {
                    x: e.screenX,
                    y: e.screenY,
                };
            }
        }}
    />);
}

/** book/pages/08/index.dom.html => 08 */
function basedir(path: string) {
    const prefix = 'book/pages/';
    return prefix + path.slice(prefix.length).split('/')[0];
}
